// loadSpeedtest.js
'use strict';
import loadScriptTag from '../resource/loadScriptTag.js';

/**
 * Load speedtest
 */
const loadSpeedtest = async ({ speedtestSrc }) => {
  await loadScriptTag({
    id: 'speedtest-script',
    async: false,
    src: speedtestSrc,
  });
};

export default loadSpeedtest;
